import { DocumentStatusEnum } from "../documents/document-status.enum";
import { AsicStatus } from "../documents/asic-status.enum";
import { SigningStatus } from "./annual-statement-enums";
import { sharesChangeTypes } from "@pages/shares/components/shares-page/shares-change-types";
import { ReminderRecord } from "../reminders/reminder-record";
import { ReminderType } from "../reminders/reminder.enum";

export class DocumentRecord {
    documentName: string;
    documentId: string;
    entityId: string;
    entityName: string;
    entityNumber: string;
    description: string;
    asicStatus: AsicStatus;
    status?: DocumentStatusEnum;
    signingStatus?: SigningStatus;
    lodgedOn?: Date;
    lodgementDeadline?: Date;
    asicDocumentNumber?: string | null;
    asicTraceNumber?: string;
    createdOn: Date;
    modifiedOn: Date;
    type: string;
    checked: boolean;
    earliestChangeDate: Date | null;
    dateSigned: Date | null;
    accountManagerFullName: string;
    accountManagerId: string;
    lastEditorFullName: string;
    LastEditorId: string;
    lateFee: number;
    hasLateFee: boolean;
    hasShareIssues: boolean;
    changeTypes: string[];
    reminders: ReminderRecord[];

    constructor(documentRecord: Partial<DocumentRecord> = {}) {
        this.documentName = documentRecord.documentName ?? '';
        this.documentId = documentRecord.documentId ?? '';
        this.entityId = documentRecord.entityId ?? '';
        this.entityName = documentRecord.entityName ?? '';
        this.entityNumber = documentRecord.entityNumber ?? '';
        this.description = documentRecord.description ?? '';
        this.asicStatus = documentRecord.asicStatus ?? AsicStatus.NotLodged;
        this.signingStatus = documentRecord.signingStatus;
        this.lodgedOn = documentRecord.lodgedOn;
        this.lodgementDeadline = documentRecord.lodgementDeadline;
        this.status = documentRecord.status;
        this.createdOn = documentRecord.createdOn ? new Date(documentRecord.createdOn) : new Date();
        this.modifiedOn = documentRecord.modifiedOn ? new Date(documentRecord.modifiedOn) : new Date();
        this.type = documentRecord.type ?? '';
        this.checked = documentRecord.checked ?? false;
        this.earliestChangeDate = documentRecord.earliestChangeDate ? new Date(documentRecord.earliestChangeDate) : new Date();
        this.asicDocumentNumber = documentRecord.asicDocumentNumber ?? null;
        this.asicTraceNumber = documentRecord.asicTraceNumber ?? '';
        this.dateSigned = documentRecord.dateSigned ? new Date(documentRecord.dateSigned) : null;
        this.accountManagerFullName = documentRecord.accountManagerFullName ?? '';
        this.accountManagerId = documentRecord.accountManagerId ?? '';
        this.lastEditorFullName = documentRecord.lastEditorFullName ?? '';
        this.LastEditorId = documentRecord.LastEditorId ?? '';
        this.lateFee = documentRecord.lateFee ?? 0;
        this.hasLateFee = documentRecord.hasLateFee ?? false;
        this.hasShareIssues = documentRecord.hasShareIssues ?? false;
        this.changeTypes = documentRecord.changeTypes?.filter(Boolean) ?? [];
        this.reminders = documentRecord.reminders ?? [];
    }

  get isActionsForbidCauseShareIssue(): boolean {
    return this.hasShareIssues && this.changeTypes.some((type) => sharesChangeTypes.includes(type));
  }

    get signingReminders(): ReminderRecord[] {
      return this.reminders.filter((reminder) => reminder.type === ReminderType.Signing);
    }

    static isImportedDocument(documentRecord: Partial<DocumentRecord>): boolean {
      return documentRecord.type == 'Imported';
    }

    static isDocumentInvoice(documentRecord: Partial<DocumentRecord>): boolean {
      return documentRecord.type == 'RC09';
    }
}
